import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { environment } from '@dp/environments/environment';

import { AppComponent } from './ui/app.component';
import { appConfig } from './ui/app.config';

if (environment.production) enableProdMode();

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
